import styled from 'styled-components';

export default styled.div`
  color: ${p => p.theme.colors.darkTheme};
  font-size: 40px;
  padding: 15px 0 15px;
`;
